<template>
    <div id="ContainerPatient">
        <div class="row">
            <div class="col-12">
                <b-row>
                    <b-col>
                        <MdButton
                            v-bind:Label="$t('Add Voice Prompt')"
                            v-bind:ClassProp="false ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                            v-on:click="AddCommand"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-bind:Name="'btn_add_voice_prompt'"
                            >
                        </MdButton>
                    </b-col>
                    <b-col>
                        <div class="textlabel" :data-label="this.$t('Search Voice Prompt')">
                            <div class="input-group">
                                <input 
                                type="text" 
                                class="form-control"
                                v-model="parameter.SearchCriteria"
                                @keyup.enter="searchListing()"
                                >
                                <div class="input-group-append">
                                    <MdButton
                                    v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="searchListing">
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col>
                        <b-form-checkbox v-model="parameter.IsActive" @change="searchListing()" switch>{{ $t('Show Active Only') }}</b-form-checkbox>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="row">
          <div class="col-12">
              <div>
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/> 
                        <MdTable 
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="'tableCommand'"                      
                        v-bind:VisibleDeleteIcon="true"
                        v-bind:VisibleEditIcon="true"
                        :editIconEvent="EditIcon"                                  
                        :deleteIconEvent="DeleteIcon"           
                        :onRowSelected="onRowSelected"
                        :onFiltered="onFiltered"
                        :pageChanged="pageChanged"
                        :perPageFunction="PerPageFunction">
                      </MdTable>                    
              </div>
          </div>
      </div>

      <MdCommandEditorModal
        v-model="showCommandEditorModal"
        :editing-command="selectedCommand"
        @saveCommand="onSaveCommand"
    />
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import UserVoiceService from '@/services/uservoice.service'
//import LocalStorage from '@/services/storage.service'
//import { EventBus } from '@/event-bus.js';

export default {
    mixins: [ShowMessage, DBFunctions],
    name: 'MdCommandSetupPanel',
    props: {
        userId: String
    },
    data() {
        return {
            parameter: {
                SearchCriteria: '',
                UserId: this.userId,
                IsActive: true,
                PageNumber : 0,
                PageSize:0,
            },
            fields: [
                { key: 'phrase', label: this.$t('Voice Prompt'), sortable: true },
                { key: 'content', label: this.$t('Content'), sortable: true },
                { key: 'isActive', label: this.$t('Active'), sortable: false }
            ],
            items: [],
            totalRows: 4,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, 20],
            ShowMessageIsEmpty: true,
            selectedCommand: {},
            showCommandEditorModal: false
        };
    },
    methods: {
        AddCommand() {
            this.selectedCommand = {};
            this.showCommandEditorModal = true;
        },
        EditCommand(item) {
            this.selectedCommand = item;
            this.showCommandEditorModal = true;
        },
        searchListing() {
            this.currentPage = 1;
            this.SearchVoicePrompt();
        },
        async SearchVoicePrompt() {
            this.parameter.PageSize = this.perPage;
            this.parameter.PageNumber = this.currentPage;
            console.log('Searching commands with parameters:', this.parameter);
            await UserVoiceService.listingCommands(this.parameter)
                .then(response => {
                    this.items = response.data;
                    this.totalRows = response.data.length;
                    this.ShowMessageIsEmpty = this.items.length === 0;
                })
                .catch(error => {
                    this.showMessage(this.$t('Error fetching commands'), error);
                });
        },
        DeleteIcon(item) {
            UserVoiceService.deleteCommand(item.recID, item.userID)
                .then(() => {
                    this.SearchVoicePrompt();
                })
                .catch(error => {
                    this.showMessage(this.$t('Error deleting command'), error);
                });
        },
        EditIcon(item) {
            this.selectedCommand = item;
            console.log(item)
            this.showCommandEditorModal = true;
        },
        async onSaveCommand(command) {
            try {
                let parameter = {
                    userID: command.userId,
                    content: command.content,
                    phrase: command.phrase,
                    phrase_normalized: command.phrase.toLowerCase(),
                    isActive: command.isActive
                }
                if(command.isEdit) {
                    await UserVoiceService.updateCommand(command.recID, parameter);
                } else {
                    await UserVoiceService.createCommand(parameter);
                }
                this.SearchVoicePrompt();
            } catch (error) {
                this.showMessage(this.$t('Error saving command'), error);
            }
        },
        onRowSelected() {

        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
        },
        pageChanged(page) {
            this.currentPage = page;
        },
        PerPageFunction(perPage) {
            this.perPage = perPage;
        }
    },
    mounted() {
        this.SearchVoicePrompt();
    }
}

</script>